import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import apiService from '../services/apiService';
import SEOHead from '../components/SEOHead';

const Home = () => {
  const [siteInfo, setSiteInfo] = useState(null);

  useEffect(() => {
    apiService.getPublicInfo()
      .then(response => {
        setSiteInfo(response.data);
      })
      .catch(error => {
        console.error('Error fetching site info:', error);
      });
  }, []);

  return (
    <>
      <SEOHead 
        title="MyWebsite - Home"
        description="Welcome to MyWebsite! Discover engaging surveys, insightful blog posts, best deals, and interactive content. Join our community and share your opinions."
        keywords="home, surveys, blog, community, interactive content, polls, questionnaires"
      />
      {/* Hero Section */}
      <section className="hero-section">
        <Container>
          <Row>
            <Col>
              <h1 className="display-4 mb-4">Welcome to MyWebsite</h1>
              <p className="lead mb-4">
                Your go-to destination for information, insights, and community engagement.
              </p>
              <LinkContainer to="/blog">
                <Button variant="light" size="lg" className="me-3">
                  Explore Blog
                </Button>
              </LinkContainer>
              <LinkContainer to="/contact">
                <Button variant="outline-light" size="lg">
                  Get in Touch
                </Button>
              </LinkContainer>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <Container className="my-5">
        <Row className="text-center mb-5">
          <Col>
            <h2>What We Offer</h2>
            <p className="lead">Discover the features that make our platform special</p>
          </Col>
        </Row>
        
        <Row>
          <Col md={4} className="mb-4">
            <Card className="h-100 card-hover">
              <Card.Body className="text-center">
                <div className="mb-3">
                  <i className="fas fa-blog fa-3x text-primary"></i>
                </div>
                <Card.Title>Informative Blog</Card.Title>
                <Card.Text>
                  Stay updated with our latest articles, insights, and industry news.
                </Card.Text>
                <LinkContainer to="/blog">
                  <Button variant="primary">Read Blog</Button>
                </LinkContainer>
              </Card.Body>
            </Card>
          </Col>
          
          <Col md={4} className="mb-4">
            <Card className="h-100 card-hover">
              <Card.Body className="text-center">
                <div className="mb-3">
                  <i className="fas fa-users fa-3x text-success"></i>
                </div>
                <Card.Title>Community</Card.Title>
                <Card.Text>
                  Join our growing community of like-minded individuals and professionals.
                </Card.Text>
                <LinkContainer to="/register">
                  <Button variant="success">Join Us</Button>
                </LinkContainer>
              </Card.Body>
            </Card>
          </Col>
          
          <Col md={4} className="mb-4">
            <Card className="h-100 card-hover">
              <Card.Body className="text-center">
                <div className="mb-3">
                  <i className="fas fa-envelope fa-3x text-info"></i>
                </div>
                <Card.Title>Get in Touch</Card.Title>
                <Card.Text>
                  Have questions or suggestions? We'd love to hear from you.
                </Card.Text>
                <LinkContainer to="/contact">
                  <Button variant="info">Contact Us</Button>
                </LinkContainer>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* About Section */}
      <Container className="my-5">
        <Row>
          <Col lg={8} className="mx-auto text-center">
            <h2>About MyWebsite</h2>
            <p className="lead">
              {siteInfo ? siteInfo.description : 'Loading...'}
            </p>
            <p>
              Built with modern technologies including React and Spring Boot, 
              our platform provides a seamless experience for users to access 
              information, engage with content, and connect with our community.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;